import type { PlaybookSectionApplicabilityCondition } from "@repo/app-types/entities/filterConditions";
import type { PlaybookId } from "@repo/app-types/entities/playbook";
import { SimpleMenu } from "@repo/ui/Menu/simpleMenu";
import { SimpleMenuItem } from "@repo/ui/Menu/simpleMenuItem";
import type { FC } from "react";

export interface PlaybookSectionCriterionMenuProps {
  playbookId: PlaybookId;
  sectionId: string;
  onSelect: (condition: PlaybookSectionApplicabilityCondition) => void;
}

export const PlaybookSectionCriterionMenu: FC<
  PlaybookSectionCriterionMenuProps
> = (props) => {
  return (
    <SimpleMenu aria-label="Section applicability">
      <SimpleMenuItem
        onAction={() =>
          props.onSelect({
            playbookId: props.playbookId,
            sectionId: props.sectionId,
            operator: "=",
            value: true,
          })
        }
      >
        is applicable
      </SimpleMenuItem>

      <SimpleMenuItem
        onAction={() =>
          props.onSelect({
            playbookId: props.playbookId,
            sectionId: props.sectionId,
            operator: "=",
            value: false,
          })
        }
      >
        is not applicable
      </SimpleMenuItem>
    </SimpleMenu>
  );
};
